module.exports = __webpack_public_path__ + "img/hr-green-desert-bush-05.a719dd7f.png";